import { adNotam } from '../../init';

adNotam.website.landingpage = {
  init: function () {}
};
